import { render, staticRenderFns } from "./CotacaoRespostaCompradorCardLinks.vue?vue&type=template&id=de42e430&scoped=true&"
import script from "./CotacaoRespostaCompradorCardLinks.vue?vue&type=script&lang=js&"
export * from "./CotacaoRespostaCompradorCardLinks.vue?vue&type=script&lang=js&"
import style0 from "./CotacaoRespostaCompradorCardLinks.vue?vue&type=style&index=0&id=de42e430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42e430",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VDivider,VSubheader})
